module.exports = __webpack_public_path__ + "img/top7_img4.0eae3a23.png";